import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { axiosGet, axiosPatch, axiosPost } from 'Redux/axiosHelper'
import {
  MentorRequestForEvent,
  MentorRequestForEventStep1Payload,
} from 'types/mentorRequest/mentorRequest'

// get mentor request for events or league
const getMentorRequestForEvent = async (
  eventId: string,
  reference?: 'event' | 'league' | 'class',
) => {
  const response = await axiosGet(
    `v1/mentor-request/${
      reference === 'event' ? 'get-requests' : reference === 'league' ? 'league-requests' : 'class-requests'
    }/${eventId}`,
  )
  return response.data
}
export const useGetMentorRequestForEvent = (
  eventId: string,
  reference: 'event' | 'league' | 'class',
) => {
  const requestsForEvent = useQuery<MentorRequestForEvent>(
    ['mentor-reqeust-for-event'],
    () => getMentorRequestForEvent(eventId, reference),
    { enabled: false },
  )
  return requestsForEvent
}

// create mentor requestr for event
const createMentorRequestForEvent = async (
  payload: MentorRequestForEventStep1Payload,
) => {
  const response = await axiosPost(
    payload,
    `v1/mentor-request/create-event-request1`,
  )
  return response.data
}

export const useCreateMentorRequestForEvent = () => {
  const queryClient = useQueryClient()
  return useMutation(createMentorRequestForEvent, {
    onSuccess: data => {
      queryClient.setQueryData(
        ['mentor-reqeust-for-event'],
        (oldData: MentorRequestForEvent) => {
          if (!oldData) return data
          return {
            ...oldData,
            ...data,
          }
        },
      )
    },
  })
}

// edit mentor request for event
const updateMentorRequestForEvent = async ({
  payload,
  requestId,
}: {
  payload: any
  requestId: string
}) => {
  const response = await axiosPatch(payload, `v1/mentor-request/${requestId}`)
  return response.data
}

export const useUpdateMentorRequestForEvent = () => {
  const queryClient = useQueryClient()
  return useMutation(updateMentorRequestForEvent, {
    onSuccess: data => {
      queryClient.setQueryData(
        ['mentor-reqeust-for-event'],
        (oldData: MentorRequestForEvent) => {
          if (!oldData) return data
          return {
            ...oldData,
            ...data,
          }
        },
      )
    },
  })
}
